/*
 * HomePage Messages
 *
 * This contains all the text for the HomePage component.
 */
import { defineMessages } from 'react-intl';

export const scope = 'boilerplate.components.Header';

export default defineMessages({
  home: {
    id: `${scope}.home`,
    defaultMessage: 'Proyectos',
  },
  features: {
    id: `${scope}.features`,
    defaultMessage: 'Experiencia',
  },
  contact: {
    id: `${scope}.contact`,
    defaultMessage: 'Contacto',
  },
});
